import React from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { AWARDS } from "../../lib/winners";

const TONE = {
  1: "from-gold-200 via-gold-400 to-gold-600 text-navy-950",
  2: "from-white via-slate-200 to-slate-400 text-navy-950",
  3: "from-amber-300 via-amber-500 to-amber-700 text-navy-950",
};

export function WinnerBadge({ slug, link = false, size = "sm", className = "" }) {
  const a = AWARDS[slug];
  if (!a) return null;
  const cls = `relative inline-flex items-center gap-1.5 overflow-hidden rounded-pill bg-gradient-to-r font-bold shadow-[0_6px_18px_-6px_rgba(201,166,70,0.7)] ${TONE[a.rank]} ${size === "lg" ? "px-3 py-1.5 text-[13px]" : "px-2.5 py-1 text-[11px]"} ${className}`;
  const inner = (
    <>
      <span className="winners-shine absolute inset-0" aria-hidden="true" />
      <Trophy size={size === "lg" ? 15 : 12} className="relative" />
      <span className="relative">{a.label}</span>
    </>
  );
  return link
    ? <Link to="/winners" className={cls} data-testid={`winner-badge-${slug}`} aria-label={`Winner: ${a.label}. See all winners`}>{inner}</Link>
    : <span className={cls} data-testid={`winner-badge-${slug}`}>{inner}</span>;
}
